import { render } from "./Inventory_Section_Dialog.vue?vue&type=template&id=d1bf7266&scoped=true&ts=true"
import script from "./Inventory_Section_Dialog.vue?vue&type=script&lang=ts"
export * from "./Inventory_Section_Dialog.vue?vue&type=script&lang=ts"

import "./Inventory_Section_Dialog.vue?vue&type=style&index=0&id=d1bf7266&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1bf7266"]])

export default __exports__